<template>
  <div class="handleContract">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      :before-close="handleClose"
    >
      <div class="form_box">
        <el-form
          ref="formInline"
          :model="formInline"
          :rules="rules"
          label-width="140px"
        >
          <el-form-item label="合同名称" prop="name">
            <el-input
              v-model="formInline.name"
              :disabled="status === 'audit'"
              maxlength="50"
              style="width: 350px"
              placeholder="请输入合同名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="合同生效日期" prop="contractValidityStart">
            <el-date-picker
              v-model="formInline.contractValidityStart"
              type="date"
              :disabled="status === 'audit'"
              :editable="false"
              placeholder="开始时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="合同截止日期" prop="contractValidityEnd">
            <el-date-picker
              v-model="formInline.contractValidityEnd"
              type="date"
              :disabled="status === 'audit'"
              :editable="false"
              placeholder="截止时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="合同附件" prop="fileurl">
            <el-upload
              ref="upload"
              :limit="1"
              :format="['pdf']"
              accept=".pdf, .PDF"
              :disabled="status === 'audit'"
              :action="uploadHost"
              :data="uploadData"
              :before-upload="beforeUpload"
              :on-success="handleSuccess"
              :on-remove="handleRemove"
              :clearFiles="clearFiles"
              :file-list="file_list"
              :on-error="handleFormatError"
            >
              <el-button slot="trigger" size="small" :disabled="status === 'audit'" type="primary"
                >上传文件</el-button
              >
              <div slot="tip" class="el-upload__tip">支持.PDF格式文件</div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button v-if="status !== 'audit'" size="small" type="primary" @click="handleAffirm">确 定</el-button>
        <el-button v-if="status === 'audit'" size="small" type="danger" @click="innerVisible = true">审核驳回</el-button>
        <el-button v-if="status === 'audit'" size="small" type="primary" @click="auditCompanyContract(1)">审核通过</el-button>
      </span>

      <el-dialog
        width="500"
        title="驳回原因"
        :visible.sync="innerVisible"
        append-to-body>
          <el-form
            ref="ruleForm"
            :model="ruleForm"
            :rules="rules1"
            label-width="140px"
          >
            <el-form-item label="驳回原因" prop="reason">
              <el-input
                v-model="ruleForm.reason"
                type="textarea"
                :rows="2"
                maxlength="500"
                placeholder="请输入驳回原因"
              ></el-input>
            </el-form-item>
          </el-form>

          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="handleClose1">关 闭</el-button>
            <el-button size="small" type="primary" @click="rejected">确 定</el-button>
          </span>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
// 引入生成上传参数方法
import { oss } from "@/libs/uploadFile";
import { getpublicImgUrl } from "@/api/base/api-upload";
import {
  addCompanyContract,
  getCompanyContract,
  updateCompanyContract,
  auditCompanyContract
} from "@/api/organization";
export default {
  data() {
    return {
      // 附件上传路径
      uploadHost: "",
      type: 0,
      path: "public/product/",
      // 附件上传携带参数
      uploadData: {},
      fileData: {
        // 上传后返回的存储的文件名
        fileName: "",
        oFileName: "",
        fileUrl: "",
        uploadRes: null,
      },
      file_list: [],
      dialogTitle: "",
      dialogVisible: false,
      formInline: {
        name: "",
        contractValidityStart: "",
        contractValidityEnd: "",
        fileurl: "",
      },
      rules: {
        name: [{ required: true, message: "请输入合同名称", trigger: "blur" }],
        contractValidityStart: [
          { required: true, message: "请选择合同生效日期", trigger: "change" },
        ],
        contractValidityEnd: [
          { required: true, message: "请选择合同截止日期", trigger: "change" },
        ],
        fileurl: [{ required: true, message: "请上传合同附件" }],
      },
      companyId: "",
      status: "",
      innerVisible: false,
      ruleForm: {
        reason: ''
      },
      rules1: {
        reason: [{ required: true, message: "请输入驳回原因", trigger: "blur" }]
      }
    };
  },
  watch: {
    "formInline.fileurl": {
      handler(to) {
        if (to) {
          this.$refs.formInline.clearValidate("fileurl");
        }
      },
      deep: true,
    },
  },
  methods: {
    // 初始化
    init(status, payload, companyId) {
      this.companyId = companyId || "";
      this.status = status || "";
      this.initData(payload);
      this.dialogTitle = status === "add" ? "添加合同" : "编辑合同";
      this.dialogVisible = true;
      this.$nextTick(()=>{
        this.$refs.formInline.clearValidate();
      })
    },
    // 初始化数据
    initData(payload) {
      if (this.status === "add") {
        this.formInline = this.$options.data().formInline;
        this.file_list = [];
      } else if (this.status === "alter" || this.status === "audit") {
        this.getCompanyContract(payload.id);
      }
    },
    // 获取合同详细信息
    getCompanyContract(id) {
      getCompanyContract({ id }).then((res) => {
        if (res.code === 0) {
          this.formInline = {
            id: res.data?.id || "",
            name: res.data?.name || "",
            contractValidityStart: res.data?.contractValidityStart.substring(0,10) || "",
            contractValidityEnd: res.data?.contractValidityEnd.substring(0,10) || "",
            fileurl: res.data?.fileurl || "",
          };
          this.file_list = [
            { name: `${res.data?.name}.pdf`, url: res.data?.fileurl },
          ];
        }
      });
    },
    // 取消
    handleClose() {
      this.dialogVisible = false;
    },
    handleClose1() {
      this.$parent.refresh()
      this.innerVisible = false;
      this.ruleForm.reason = ''
    },
    rejected() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.auditCompanyContract(2)
        }
      })
    },
    async auditCompanyContract(auditState) {
      const res = await auditCompanyContract({ id: this.formInline.id, auditState: auditState, reason: this.ruleForm.reason })
      this.$message.success('操作成功!')
      this.handleClose1()
      this.handleClose()
    },
    // 确认
    handleAffirm() {
      this.$refs["formInline"].validate((valid) => {
        if (valid) {
          let start = new Date(this.formInline.contractValidityStart).getTime();
          let end = new Date(this.formInline.contractValidityEnd).getTime();
          if (start >= end) {
            this.$message({
              message: "生效日期请小于截止日期",
              type: "warning",
            });
            return;
          }

          this.formInline.contractValidityStart = this.formInline.contractValidityStart + ' 00:00:00';
          this.formInline.contractValidityEnd = this.formInline.contractValidityEnd + ' 23:59:59';
          if (this.status === "add") {
            addCompanyContract({
              ...this.formInline,
              companyId: this.companyId,
            }).then((res) => {
              if (res.code === 0) {
                this.$parent.refresh();
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.dialogVisible = false;
              }
            });
          } else if (this.status === "alter") {
            updateCompanyContract({
              ...this.formInline,
              companyId: this.companyId,
            }).then((res) => {
              if (res.code === 0) {
                this.$parent.refresh();
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.dialogVisible = false;
              }
            });
          }
        }
      });
    },
    beforeUpload(file) {
      return oss(file.name, this.type, this.path).then((res) => {
        this.uploadHost = res.host;
        this.uploadData = res;
        this.fileData.fileName = res.key;
        this.fileData.oFileName = file.name;
        this.fileData.fileUrl = res.key;
      });
    },
    // 上传成功的回调函数
    handleSuccess(res, file, fileList) {
      this.uploadRes = res;
      if (this.type === 0) {
        // 获取公有链接
        getpublicImgUrl(this.fileData.fileName).then((res) => {
          if (res.code === 0) {
            this.fileData.fileUrl = res.data;
            this.formInline.fileurl = res.data;
            this.fileData.name = this.fileData.fileName;
            this.fileData.url = res.data;
            this.$emit("input", res.data);
          } else {
            this.$message.success("获取图片链接失败");
          }
        });
      }
    },
    clearFiles() {
      this.fileData = {
        fileName: "",
        fileUrl: "",
        uploadRes: null,
      };
      this.file_list = [];
    },
    handleRemove() {
      this.formInline.fileurl = "";
    },
    handleFormatError(file) {
      this.$message({
        message: "图片格式错误",
        type: "warning",
      });
    },
  },
};
</script>
